/* eslint-disable no-useless-escape */
import md5 from './md5'
// 设置cookie
export function setCookie (cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + '; ' + expires
}
// 获取cookie
export function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) !== -1) return c.substring(name.length, c.length)
  }
  return ''
}
// 清除cookie
export function clearCookie (name) {
  setCookie(name, '', -1)
}
// md5加密
export function md5hex (str) {
  let md5hex = ''
  md5hex = md5.hex_md5(str)
  return md5hex
}
export function trim (val) {
  if (val) {
    return (val.replace(/(^\s*)|(\s*$)/g, ''))
  } else {
    return ''
  }
}
// 截取location.search并转换成对象
export function formatSearch (se) {
  if (typeof se !== 'undefined') {
    se = se.substr(1)
    var arr = se.split('&')
    var obj = {}
    var newarr = []
    arr.forEach((i, v) => {
      newarr = i.split('=')
      if (typeof obj[newarr[0]] === 'undefined') {
        obj[newarr[0]] = decodeURI(newarr[1])
      }
    })
    return obj
  };
}

// img类型转换
export function switchImgSort (sort) {
  if (sort.indexOf('jp') >= 0) {
    return '.jpg'
  } else if (sort.indexOf('png') >= 0) {
    return '.png'
  } else if (sort.indexOf('bmp') >= 0) {
    return '.bmp'
  } else if (sort.indexOf('gif') >= 0) {
    return '.gif'
  }
}
// 获取url参数
export function getParmUrl (name) {
  let search = document.location.search
  // alert(search);
  let pattern = new RegExp('[?&]' + name + '\=([^&]+)', 'g')
  let matcher = pattern.exec(search)
  let items = null
  if (matcher != null) {
    try {
      items = decodeURIComponent(decodeURIComponent(matcher[1]))
    } catch (e) {
      try {
        items = decodeURIComponent(matcher[1])
      } catch (e) {
        items = matcher[1]
      }
    }
  }
  return items
}
export function browserIsPc () {
  let isPc = false
  if (/iphone|ipod|ipad|ipad|Android|nokia|blackberry|webos|webos|webmate|bada|lg|ucweb|skyfire|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(navigator.userAgent.toLowerCase())) {
    isPc = false
  } else {
    isPc = true
  }
  return isPc
}
// 公告类型转换
export function switchAnnounceSort (sort) {
  if (sort.indexOf('WebSite') >= 0) {
    return '整站公告'
  } else if (sort.indexOf('Members') >= 0) {
    return '会员短信'
  } else if (sort.indexOf('Home') >= 0) {
    return '首页公告'
  } else if (sort.indexOf('Activity') >= 0) {
    return '活动公告'
  }
}
// 根据路由地址查找头部menu相关的key
export function switchTabBarIndex (url) {
  if (url.indexOf('main') < 0) {
    return 1
  }
  const realUrl = url.split('main')[1].split('/')[1]
  if (realUrl.indexOf('order') >= 0) {
    return 1
  } else if (realUrl.indexOf('item') >= 0) {
    return 2
  } else if (realUrl.indexOf('socialcontact') >= 0) {
    return 3
  } else if (realUrl.indexOf('content') >= 0) {
    return 4
  } else if (realUrl.indexOf('marketinguser') >= 0) {
    return 6
  } else if (realUrl.indexOf('marketing') >= 0) {
    return 5
  } else if (realUrl.indexOf('finance') >= 0) {
    return 7
  } else if (realUrl.indexOf('service') >= 0) {
    return 8
  } else {
    return 1
  }
}
//  正則
export function regxps () {
  return {
    phone: /^(1[0-9])[0-9]{9}$/,
    email: /(^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]{2,}$)/,
    idCard: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
    phoneCode: /^\d{4}$/,
    telphone: /^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/
  }
}

export function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
// 千分位
export function format (num = 0, isMoney = true) {
  if (!num && num !== 0) {
    return 0
  }
  let nums = num
  if (isMoney) {
    nums = (nums * 1).toFixed(2)
  } else {
    nums = (nums * 1) + ''
  }
  nums = nums.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
  return nums
}

//数字格式化
export function priceFixed(num) {
  if (!num && num !== 0) {
    return 0
  }
  var str = parseFloat(num) + "";
  if (str.indexOf('.') < 0) {
    return str;
  }
  else {
    if (str.split('.')[1].length >= 2) {
      str = parseFloat(num).toFixed(2)
    } else {
      str = parseFloat(num).toFixed(1)
    }
    return str;
  }
}
// 数字格式化
export function numberFormat (number, decimals, decPoint, thousandsSep, roundtag) {
  /*
* 参数说明：
* number：要格式化的数字
* decimals：保留几位小数
* decPoint：小数点符号
* thousandsSep：千分位符号
* roundtag:舍入参数，默认 "ceil" 向上取,"floor"向下取,"round" 四舍五入
* numberFormat(text,0,".",",") 千分位整数
* */
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  decimals = typeof decimals === 'undefined' ? 2 : decimals
  roundtag = roundtag || 'ceil' // "ceil","floor","round"
  var n = !isFinite(+number) ? 0 : +number
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  var s = ''
  var toFixedFix = function (n, prec) {
    var k = Math.pow(10, prec)
    return '' + parseFloat(Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(prec * 2)) / k
  }
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  var re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}

// 时间戳转日期
export function formatDate (_now) {
  var now = new Date(_now)
  var year = now.getFullYear()
  var month = now.getMonth() + 1
  if (month.toString().length < 2) {
    month = '0' + month
  }
  var date = now.getDate()
  if (date.toString().length < 2) {
    date = '0' + date
  }
  var hour = now.getHours() < 10 ? ('0' + now.getHours()) : now.getHours()
  var minute = now.getMinutes() < 10 ? ('0' + now.getMinutes()) : now.getMinutes()
  var second = now.getSeconds() < 10 ? ('0' + now.getSeconds()) : now.getSeconds()
  return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
  // return year+"/"+month+"/"+date
}
// 时间转换
export function newswitchTime (postTime) {
  const HOUR_TIMESTAMP = 3600000
  const MINUTE_TIMESTAMP = 60000
  const DAY_TIMESTAMP = 86400000
  const TWO_DAY_TIMESTAMP = 172800000
  const THREE_DAY_TIMESTAMP = 259200000
  const currentTime = new Date() // 当前日期
  const publishTime = new Date(parseInt(postTime)) // 传入时间
  const NOWY = currentTime.getFullYear()
  const NOWM = currentTime.getMonth() + 1
  const NowD = currentTime.getDate()
  const today = `${NOWY}-${NOWM}-${NowD}`
  const todayTime = new Date(today).getTime() - 28800000 // 此时间以8点为基准计算需要减去8小时时间戳
  const yesterdayTime = new Date(todayTime - DAY_TIMESTAMP).getTime()
  const lastYesterdayTime = new Date(todayTime - TWO_DAY_TIMESTAMP).getTime()
  const Y = publishTime.getFullYear()
  const M = publishTime.getMonth() + 1
  const D = publishTime.getDate()
  const h = (publishTime.getHours() < 10 ? '0' + publishTime.getHours() : publishTime.getHours())
  const m = (publishTime.getMinutes() < 10 ? '0' + publishTime.getMinutes() : publishTime.getMinutes())
  const s = (publishTime.getSeconds() < 10 ? '0' + publishTime.getSeconds() : publishTime.getSeconds())
  if ((currentTime - postTime) <= HOUR_TIMESTAMP) {
    let tempTime = (currentTime - postTime) / MINUTE_TIMESTAMP
    if (tempTime < 1) {
      return '刚刚'
    } else {
      return parseInt(tempTime) + '分钟前'
    }
  } else if (postTime >= todayTime) {
    return '今天' + h + ':' + m
  } else if (postTime < todayTime && yesterdayTime <= postTime) {
    return '昨天' + h + ':' + m
  } else if (postTime < yesterdayTime && lastYesterdayTime <= postTime) {
    return '前天' + h + ':' + m
  } else if (NOWY === Y) {
    // 今年 （2-3 12:30）
    return M + '-' + D + ' ' + h + ':' + m
  } else if (NOWY > Y) {
    // 往年 （19-12-30）
    return Y.toString().slice(2) + '-' + M + '-' + D
  }
}

/**
 * 版本比较
 * @param {string} a
 * @param {string} b
 * @return {number} -1 | 0 | 1
 */
export function compareVersion (a, b) {
  let arrA = a.split('.')
  let arrB = b.split('.')
  const len = Math.max(arrA.length, arrB.length)
  while (arrA.length < len) {
    arrA.push('0')
  }
  while (arrB.length < len) {
    arrB.push('0')
  }
  for (let i = 0; i < len; i++) {
    const numA = parseInt(arrA[i])
    const numB = parseInt(arrB[i])
    if (numA > numB) {
      return 1
    } else if (numA < numB) {
      return -1
    } else {
      //
    }
  }
  return 0
}
/**
 * @msg: 有大写转换成小写
 * @param {*} str
 * @return {*}
 */
export function upperChangeLower (str = '') {
  let c = str.split('')
  for (let i = 0; i < c.length; i++) {
    if (c[i].search(/[A-Z]/) !== -1) {
      c[i] = c[i].toLowerCase()
    }
  }
  return c.join('')
}
/**
 * @msg: 把对象的字段转换成全小写字段
 * @param {*} obj
 * @return {*}
 */
export function changeObjUpper (obj = {}) {
  let newObj = {}
  for (let i in obj) {
    if (typeof (obj[i]) === 'boolean') {
      let temp = obj[i]
      i = 'is' + upperChangeLower(i)
      newObj[i] = temp
    } else {
      newObj[upperChangeLower(i)] = obj[i]
    }
  }
  return newObj
}



// WEBPACK FOOTER //
// ./src/public/utils.js